import { CalendarColumnBodyVariant, CalendarEventType } from './types';

export const CALENDAR_GRID_TIME_FORMAT = 'h:mm A'; // 12-hour format with AM/PM

export const MIN_COLUMN_WIDTH: Record<CalendarColumnBodyVariant, number> = {
  stacked: 50,
  grid: 200,
};

export const CALENDAR_Z_INDICES = {
  debugControls: 100,
  dragCreateSelectionOverlay: 100,
  topCornerCell: 100, // above all other cells
  groupHeader: 90,
  eventDragHandle: 80,
  timeColumn: 80,
  currentTimeIndicatorBadge: 85,
  currentTimeIndicatorLine: 75,
  gridLines: 35,
};

export const EVENT_Z_INDICES: Record<CalendarEventType, number> = {
  // Background blocks — lowest layer
  unavailableBlock: 30,
  availableBlock: 30,
  exception: 30,
  workingHoursV3: 30,
  nonWorkingHoursV3: 30,
  scheduleDefinition: 40,
  // Pending / secondary events
  cancelledAppointment: 50,
  appointment: 50,
  scheduleRequest: 51,
  // UI controls — topmost event layer
  availabilitySlot: 60,
  nonInteractiveSlot: 60,
  slotsStartLabel: 60,
};

export const PX_PER_MINUTE = 2; // 1 minute = 2px, so 15 minutes = 30px
export const TOTAL_HOURS = 24;

export const SPACER_ROW_HEIGHT = 30; // 30px for the spacer row between the header and body of the grid
